const removeArrayItemAt = (arr: Array<any>, index = -1) => {
  if (index > -1) {
    arr.splice(index, 1);
  }

  return arr;
};

export default removeArrayItemAt;
